import Splide from "@splidejs/splide";

const slider = document.querySelector("#splide");

if (slider) {
    new Splide("#splide", {
        type: "loop",
        arrows: false,
        autoplay: true
    }).mount();
}
